import { useBodyClass } from '@toss/react';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { LandingBusinessProposal, LandingExperience, LandingFAQ, LandingIntro, LandingMyMetaverse, LandingPremium, LandingUsedClient, LandingWhy } from '../../components/service/home';
import { useMotion } from '../../hooks';
import { useOnlineClassLanding } from '../../services';
import S from './Landing.module.scss';
export const OnlineClassLandingPageView = () => {
  const {
    locale
  } = useRouter();
  const {
    data
  } = useOnlineClassLanding();
  useMotion([locale, data]);
  useBodyClass('use-typography');
  return <main className={S.main} data-sentry-component="OnlineClassLandingPageView" data-sentry-source-file="onlineclass.tsx">
      {data?.LandingIntro && <LandingIntro title={data?.LandingIntro.title} source={data?.LandingIntro.source} buttonText={data?.LandingIntro.buttonText} buttonLink={data?.LandingIntro.buttonLink} onButtonClick={ctaClickTracker('intro', data?.LandingIntro)} />}
      {data?.LandingExperience && <LandingExperience title={data?.LandingExperience.title} spaces={data?.LandingExperience.spaces} buttonText={data?.LandingExperience.buttonText} buttonLink={data?.LandingExperience.buttonLink} />}
      {data?.LandingUsedClient && <LandingUsedClient title={data?.LandingUsedClient.title} description={data?.LandingUsedClient.description} logos={data?.LandingUsedClient.logos} buttonText={data?.LandingUsedClient.buttonText} buttonLink={data?.LandingUsedClient.buttonLink} onButtonClick={ctaClickTracker('useClient', data?.LandingUsedClient)} />}
      {data?.LandingWhy && <LandingWhy title={data?.LandingWhy.title} list={data?.LandingWhy.list} description={data?.LandingWhy.description} />}
      {data?.LandingMyMetaverse && <LandingMyMetaverse title={data?.LandingMyMetaverse.title} list={data?.LandingMyMetaverse.list} onItemLinkClick={item => {
      if (item.id === 1) {
        logger.track('landing_create_space_template_online');
      }
      if (item.id === 2) {
        logger.track('landing_create_space_template_adult');
      }
    }} />}
      {data?.LandingBusinessProposal && <LandingBusinessProposal title={data?.LandingBusinessProposal.title} description={data?.LandingBusinessProposal.description} buttonText={data?.LandingBusinessProposal.buttonText} buttonLink={data?.LandingBusinessProposal.buttonLink} />}
      {data?.LandingPremium && <LandingPremium logo={data?.LandingPremium.logo} title={data?.LandingPremium.title} description={data?.LandingPremium.description} features={data?.LandingPremium.features} buttonText={data?.LandingPremium.buttonText} buttonLink={data?.LandingPremium.buttonLink} backgroundColor={data?.LandingPremium.backgroundColor} onButtonClick={ctaClickTracker('premium', data?.LandingPremium)} />}
      {data?.LandingFAQ && <LandingFAQ title={data?.LandingFAQ.title} list={data?.LandingFAQ.list} buttonText={data?.LandingFAQ.buttonText} buttonLink={data?.LandingFAQ.buttonLink} />}
    </main>;
};
function ctaClickTracker(sectionName: string, {
  buttonLink,
  buttonText
}: {
  buttonLink: string;
  buttonText: string;
}) {
  return () => {
    logger.track('landing_cta_click_edu', {
      section_name: sectionName,
      button_link: buttonLink,
      button_text: buttonText
    });
  };
}